import { IntraSyncDesignerViewStore } from "@intrasync/designer";

const estimatingStoresList = [
  { name: "intraSyncDesignerViewStore", store: IntraSyncDesignerViewStore },
];

export default estimatingStoresList;
